module.exports = __webpack_public_path__ + "f6772a0ceb0bd12c434d54a2bf8afb4c.svg";


//////////////////
// WEBPACK FOOTER
// ./webserver/document_root/s/img/web/module/cookieSettings/icons-arrow-right.svg
// module id = 1347
// module chunks = 193 194